module.exports = require("@swa-ui/string");